module.exports = __webpack_public_path__ + "img/SAP.2bb26d49.jpg";